import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { MyBetsBet, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { VisualizationType } from '../../models/my-bets-visualization-types';
import { MyBetsUtilService } from '../../services/my-bets-util.service';
import { MyBetsVisualizationService } from '../../services/my-bets-visualization.service';
import { MyBetsCondensedScoreboardComponent } from '../scoreboard/general/my-bets-condensed-scoreboard.component';
import { MyBetsScoreboardWrapperComponent } from '../scoreboard/my-bets-scoreboard-wrapper/my-bets-scoreboard-wrapper.component';
import { MyBetsVisualizationComponent } from '../visualization/my-bets-visualization.component';

@Component({
    selector: 'ms-my-bets-betslip-scoreboard',
    standalone: true,
    imports: [MyBetsVisualizationComponent, MyBetsCondensedScoreboardComponent, MyBetsScoreboardWrapperComponent],
    templateUrl: './my-bets-betslip-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBetsBetslipScoreboardComponent {
    private myBetsVisualizationService = inject(MyBetsVisualizationService);
    private myBetsUtilService = inject(MyBetsUtilService);

    bet = input.required<MyBetsBet>();
    myBetsListContext = input.required<MyBetsListContext>();
    cashedOut = input(false);
    enableVisualization = input<boolean>(true);

    noVisualization = VisualizationType.NoVisualization;

    event = computed(() => this.bet().event);

    visualizationConfig = computed(() =>
        this.myBetsVisualizationService.getVisualizationDetails(this.event(), this.bet().sportId, this.bet().marketId),
    );

    isVisualizationTrackingEnabled = computed(() => this.myBetsVisualizationService.isTrackingEnabled(this.bet().event, this.bet().sportId));

    isGridScoreboardEnabled = computed(() => this.myBetsUtilService.isGridScoreboardEnabled(this.event()));
}
